import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

interface ITextEditor {
  editorData: string;
  setEditorData: React.Dispatch<React.SetStateAction<string>>;
}

const TextEditor: React.FC<ITextEditor> = ({ editorData, setEditorData }) => {
  return (
    <CKEditor
      editor={ClassicEditor as any}
      data={editorData}
      onReady={(editor) => {
        editor.editing.view.change((writer) => {
          writer.setStyle(
            "min-height",
            "200px",
            editor.editing.view.document.getRoot() as any
          );
        });
      }}
      onChange={(_, editor) => {
        const data = editor.getData();
        setEditorData(data);
      }}
    />
  );
};

export default TextEditor;
